export default __webpack_public_path__ + "static/media/users_icon.a7e71c96.svg";